import Image from 'next/image'

interface BackgroundImageProps {
  assetId?: string;
  temp?: string;
  priority?: boolean;
  className?: string;
  quality?: number;
}

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
  assetId = '',
  temp = '',
  priority = false,
  className,
  quality = 80
}) => {
  // Only use the temp image if assetId is empty
  const imageUrl = assetId 
    ? `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/${assetId}`
    : temp;
    
  return (
    <Image
      src={imageUrl}
      alt=""
      fill
      priority={priority}
      className={`${className}`}
      sizes="100vw"
      quality={quality}
    />
  )
}